export const WRAPPER_TYPES = {
  none: 'none',
  accordion: 'accordion',
  collapse: 'collapse',
};
